import styled, { css } from 'styled-components'

const designerCSS = css`
  #trailing_inputs_container {
    flex-direction: row;
    display: flex;
    gap: 5px;
    margin: 0;
    width: 100%;
  }
  #trailing_inputs_container fieldset {
    width: 100%;
    margin:0;
  }

  #trailing_inputs_container .trailing {
    border-radius: 10px !important;
    position: relative;
  }
  #trailing_inputs_container .trailing.amount::before {
    content:'$'
  }
  #trailing_inputs_container .trailing.percentage::after {
    content:'%'
  }
`

const developerCSS = css``

export const TrailingInputCSS = styled.div`
  width: 100%;
  ${designerCSS}
  ${developerCSS}
`
